<template>
  <div>
     <h1 class="main-header mr-4" v-translate>Events</h1>

  <div class="no-events position-relative">
    <div>
      <CImg :src="require('@/assets/images/event_wizard/event/no-events.png')" fluid block />
      <h6 class="font-weight-medium mb-2" v-translate>No events available</h6>
      <div class="message" v-translate>Create your first event now</div>
      <div>
        <CButton @click.prevent="$emit('create')" color="primary">
          <CIcon name="cip-plus" style="vertical-align: sub"/>
          <translate>New event</translate>
        </CButton>
      </div>

    </div>
  </div>
      </div>
</template>

<script>
export default {
  name: "WelcomeToPica",
  emit: ['create']
}
</script>
<style>
.fade-in-up-enter-active{
  animation: fadeInUp 0.5s ease;
}
.fade-in-up-enter{
  opacity: 0;
  transform: translateY(20px);
}
</style>